import React, { Fragment, useEffect, useState } from 'react'
import Navbar from '../../appShell/Navbar/Navbar'
import Sidebar from '../../appShell/Sidebar/Sidebar'
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Navigate, useNavigate } from 'react-router-dom';
import { handleMenuSelection, handleSubMenuSelection, reformartErrorMsg } from '../../utils/utils';
import { toast } from 'react-toastify';
import { addConfiguration, getConfiguration } from '../../services/http';
import Loader from '../../components/Loader/Loader';
import ProcessSpinner from '../../components/ProcessSpinner/ProcessSpinner';
import { FiEye } from "react-icons/fi"
import { AiFillEyeInvisible } from "react-icons/ai";



const Configuration = () => {

  const dispatch = useDispatch();
  const states = useSelector((state) => state, shallowEqual);
  const navigate = useNavigate();
  const [processOngoing, setProcessOngoing] = useState(false)
  const [showPassword, setShowPassword] = useState(false);



  // To populate the breadcrumb and update the sidebar menu
  useEffect(async () => {
    dispatch({
      type: "SET",
      key: "breadcrumbContent",
      payload: {
        firstLevelText: "Paramètres", firstLevelLink: "/settings", secondLevelText: "Alertes", secondLevelLink: "/alertes", thirdLevelText: "", thirdLevelLink: ""
      }
    });
    handleMenuSelection("settings", dispatch, states);
    handleSubMenuSelection("alertes", dispatch)
  }, [])

  const [displayLoader, setDisplayLoader] = useState(true);



  const [showErrorServer, setShowErrorServer] = useState(false);
  const [showErrorPort, setShowErrorPort] = useState(false);
  const [showErrorEmail, setShowErrorEmail] = useState(false);
  const [showErrorPassword, setShowErrorPassword] = useState(false);
  const [showErrorSmsNotif, setShowErrorSmsNotif] = useState(false);
  const [showErrorIsoCode, setShowErrorIsoCode] = useState(false);
  const [showErrorNotifMsgNormal, setShowErrorNotifMsgNormal] = useState(false);
  const [showErrorNotifMsgGrace, setShowErrorNotifMsgGrace] = useState(false);
  const [showErrorNotifMsgReminderBefore, setShowErrorNotifMsgReminderBefore] = useState(false);
  const [showErrorNotifMsgReminderPresent, setShowErrorNotifMsgReminderPresent] = useState(false);
  const [showErrorNotifMsgReminderAfter, setShowErrorNotifMsgReminderAfter] = useState(false);
  const [showErrorNumberOfDaysGivenBeforeTransmission, setShowErrorNumberOfDaysGivenBeforeTransmission] = useState(false);
  const [showErrorNumberofDaysBeforeDueDate, setShowErrorNumberofDaysBeforeDueDate] = useState(false);
  const [showErrorMaxRate, setShowErrorMaxRate] = useState(false);

  const [configuration, setConfiguration] = useState({
    server: "",
    port: "",
    email: "",
    password: "",
    smsNotif: false,
    isoCode: "",
    notifMsgNormal: "",
    notifMsgGrace: "",
    notifMsgReminderBefore: "",
    notifMsgReminderPresent: "",
    notifMsgReminderAfter: "",
    numberOfDaysGivenBeforeTransmission: "",
    numberofDaysBeforeDueDate: "",
    maxRate: ""
  })
  const [smsNotif, setSmsNotif] = useState(false)


  const [errorMessageServer, setErrorMessageServer] = useState("");
  const [errorMessagePort, setErrorMessagePort] = useState("");
  const [errorMessageEmail, setErrorMessageEmail] = useState("");
  const [errorMessagePassword, setErrorMessagePassword] = useState("");
  const [errorMessageSmsNotif, setErrorMessageSmsNotif] = useState("");
  const [errorMessageIsoCode, setErrorMessageIsoCode] = useState("");
  const [errorMessageNotifMsgNormal, setErrorMessageNotifMsgNormal] = useState("");
  const [errorMessageNotifMsgGrace, setErrorMessageNotifMsgGrace] = useState("");
  const [errorMessageNotifMsgReminderBefore, setErrorMessageNotifMsgReminderBefore] = useState("");
  const [errorMessageNotifMsgReminderPresent, setErrorMessageNotifMsgReminderPresent] = useState("");
  const [errorMessageNotifMsgReminderAfter, setErrorMessageNotifMsgReminderAfter] = useState("");
  const [errorMessageNumberOfDaysGivenBeforeTransmission, setErrorMessageNumberOfDaysGivenBeforeTransmission] = useState("");
  const [errorMessageNumberofDaysBeforeDueDate, setErrorMessageNumberofDaysBeforeDueDate] = useState("");
  const [errorMessageMaxRate, setErrorMessageMaxRate] = useState("");

  useEffect(async () => {

    const reqdata = await getConfiguration(states.userToken.access_token);
    if (reqdata.response && reqdata.response.status !== 200) {

      console.log(reqdata.response?.data?.error)
      console.log(reqdata.response?.data?.message)


    } else {

      console.log("data ", reqdata.data)
      var configData = reqdata.data

      setConfiguration({
        ...configuration,
        server: configData?.server_mail?.server,
        port: configData?.server_mail?.port,
        email: configData?.server_mail?.email,
        password: configData?.server_mail?.password,
        smsNotif: configData?.sms?.send_by_sms == 1 ? true : false,
        isoCode: configData?.sms?.code_iso,
        notifMsgNormal: configData?.notification?.message_dsif_normal,
        notifMsgGrace: configData?.notification?.message_dsif_grace,
        notifMsgReminderBefore: configData?.notification?.message_rappel_avant,
        notifMsgReminderPresent: configData?.notification?.message_rappel_jj,
        notifMsgReminderAfter: configData?.notification?.message_depassement_echeance,
        numberOfDaysGivenBeforeTransmission: configData?.calendar?.day_before_end,
        numberofDaysBeforeDueDate: configData?.calendar?.day_after_end,
        maxRate: configData?.calendar?.taux_maximal
      })

      setDisplayLoader(false)

    }


  }, []);

  const handleChangeEntry = (key, event) => {
    const value = event.target.value;
    if (key === "server") {
      setConfiguration({ ...configuration, server: value })
    }
    if (key === "port") {
      setConfiguration({ ...configuration, port: value })
    }
    if (key === "email") {
      setConfiguration({ ...configuration, email: value })
    }
    if (key === "password") {
      setConfiguration({ ...configuration, password: value })
    }
    if (key == "smsNotif") {
      if (smsNotif === true) {
        setConfiguration({ ...configuration, smsNotif: false })
        setSmsNotif(false)
      } else {
        setConfiguration({ ...configuration, smsNotif: true })
        setSmsNotif(true)
      }
    }
    if (key === "isoCode") {
      setConfiguration({ ...configuration, isoCode: value })
    }
    if (key === "notifMsgNormal") {
      setConfiguration({ ...configuration, notifMsgNormal: value })
    }
    if (key === "notifMsgGrace") {
      setConfiguration({ ...configuration, notifMsgGrace: value })
    }
    if (key === "notifMsgReminderBefore") {
      setConfiguration({ ...configuration, notifMsgReminderBefore: value })
    }
    if (key === "notifMsgReminderPresent") {
      setConfiguration({ ...configuration, notifMsgReminderPresent: value })
    }
    if (key === "notifMsgReminderAfter") {
      setConfiguration({ ...configuration, notifMsgReminderAfter: value })
    }
    if (key === "numberOfDaysGivenBeforeTransmission") {
      setConfiguration({ ...configuration, numberOfDaysGivenBeforeTransmission: value })
    }
    if (key === "numberofDaysBeforeDueDate") {
      setConfiguration({ ...configuration, numberofDaysBeforeDueDate: value })
    }
    if (key === "maxRate") {
      setConfiguration({ ...configuration, maxRate: value })
    }

    console.log("Config ", configuration)
  }

  const handleDisplayPassword = () => {
    if (showPassword === true) {
      setShowPassword(false)
    } else {
      setShowPassword(true)
    }
  }

  // Erros Managing

  useEffect(() => {
    // server
    if (configuration.server != "") {
      setShowErrorServer(false)
    }
    // port
    if (configuration.port != "") {
      setShowErrorPort(false)
    }
    // email
    if (configuration.email != "") {
      setShowErrorEmail(false)
    }
    // password
    if (configuration.password != "") {
      setShowErrorPassword(false)
    }
    // smsNotif
    //  if (configuration.smsNotif != "") {
    //     setShowError({...showError, smsNotif: false})
    // }
    // isoCode
    if (configuration.isoCode != "") {
      setShowErrorIsoCode(false)
    }
    // notifMsgNormal
    if (configuration.notifMsgNormal != "") {
      setShowErrorNotifMsgNormal(false)
    }
    // notifMsgGrace
    if (configuration.notifMsgGrace != "") {
      setShowErrorNotifMsgGrace(false)
    }
    // notifMsgReminderBefore
    if (configuration.notifMsgReminderBefore != "") {
      setShowErrorNotifMsgReminderBefore(false)
    }
    // notifMsgReminderPresent
    if (configuration.notifMsgReminderPresent != "") {
      setShowErrorNotifMsgReminderPresent(false)
    }
    // notifMsgReminderAfter
    if (configuration.notifMsgReminderAfter != "") {
      setShowErrorNotifMsgReminderAfter(false)
    }
    // numberOfDaysGivenBeforeTransmission
    if (configuration.numberOfDaysGivenBeforeTransmission != "") {
      setShowErrorNumberOfDaysGivenBeforeTransmission(false)
    }
    // numberofDaysBeforeDueDate:
    if (configuration.numberofDaysBeforeDueDate != "") {
      setShowErrorNumberofDaysBeforeDueDate(false)
    }
    // maxRate
    if (configuration.maxRate != "") {
      setShowErrorMaxRate(false)
    }

  }, [configuration])

  useEffect(() => {
    if (showErrorServer == true) {
      setTimeout(() => {
        setShowErrorServer(false)
      }, 5000);
    }
    if (showErrorPort == true) {
      setTimeout(() => {
        setShowErrorPort(false)
      }, 5000);
    }
    if (showErrorEmail == true) {
      setTimeout(() => {
        setShowErrorEmail(false)
      }, 5000);
    }
    if (showErrorPassword == true) {
      setTimeout(() => {
        setShowErrorPassword(false)
      }, 5000);
    }
    // smsNotif
    // if (showError.smsNotif == true) {
    //     setTimeout(() => {
    //         setShowError({...showError, smsNotif: false})
    //     }, 5000);
    // }
    if (showErrorIsoCode == true) {
      setTimeout(() => {
        setShowErrorIsoCode(false)
      }, 5000);
    }
    if (showErrorNotifMsgNormal == true) {
      setTimeout(() => {
        setShowErrorNotifMsgNormal(false)
      }, 5000);

    }
    if (showErrorNotifMsgGrace == true) {
      setTimeout(() => {
        setShowErrorNotifMsgGrace(false)
      }, 5000);
    }
    if (showErrorNotifMsgReminderBefore == true) {
      setTimeout(() => {
        setShowErrorNotifMsgReminderBefore(false)
      }, 5000);
    }
    if (showErrorNotifMsgReminderPresent == true) {
      setTimeout(() => {
        setShowErrorNotifMsgReminderPresent(false)
      }, 5000);
    }
    if (showErrorNotifMsgReminderAfter == true) {
      setTimeout(() => {
        setShowErrorNotifMsgReminderAfter(false)
      }, 5000);
    }
    if (showErrorNumberOfDaysGivenBeforeTransmission == true) {
      setTimeout(() => {
        setShowErrorNumberOfDaysGivenBeforeTransmission(false)
      }, 5000);
    }
    if (showErrorNumberofDaysBeforeDueDate == true) {
      setTimeout(() => {
        setShowErrorNumberofDaysBeforeDueDate(false)
      }, 5000);
    }
    if (showErrorMaxRate == true) {
      setTimeout(() => {
        setShowErrorMaxRate(false)
      }, 5000);
    }
  }, [showErrorServer, showErrorPort, showErrorEmail, showErrorPassword, showErrorIsoCode,
    showErrorNotifMsgNormal, showErrorNotifMsgGrace, showErrorNotifMsgReminderBefore,
    showErrorNotifMsgReminderPresent, showErrorNotifMsgReminderAfter,
    showErrorNumberOfDaysGivenBeforeTransmission, showErrorNumberofDaysBeforeDueDate,
    showErrorMaxRate])




  const handleSaveConfig = async () => {
    setProcessOngoing(true)
    const reqdata = await addConfiguration(configuration, states.userToken.access_token);
    if (reqdata.response && reqdata.response.status !== 200) {
      if (reqdata.response.status === 422) {
        setProcessOngoing(false)
        // console.log(reqdata.response?.data?.error["server_mail.0.server"])
        // console.log(reformartErrorMsg(reqdata.response?.data?.error["sms.code_iso"][0]))
        if (reqdata.response?.data?.error["server_mail.0.server"] && reqdata.response?.data?.error["server_mail.0.server"][0]) {
          var errorMsg = reformartErrorMsg(reqdata.response?.data?.error["server_mail.0.server"][0]);
          setShowErrorServer(true)
          setErrorMessageServer(errorMsg)
        }
        if (reqdata.response?.data?.error["server_mail.0.port"] && reqdata.response?.data?.error["server_mail.0.port"][0]) {
          var errorMsg = reformartErrorMsg(reqdata.response?.data.error["server_mail.0.port"][0]);
          setShowErrorPort(true)
          setErrorMessagePort(errorMsg)
        }
        if (reqdata.response?.data?.error["server_mail.0.email"] && reqdata.response?.data?.error["server_mail.0.email"][0]) {
          var errorMsg = reformartErrorMsg(reqdata.response?.data?.error["server_mail.0.email"][0]);
          setShowErrorEmail(true)
          setErrorMessageEmail(errorMsg)
        }
        // if (reqdata.response?.data?.error["server_mail.email"].length !== 0 && reqdata.response?.data?.error["server_mail.0.email"][1]) {
        //   var errorMsg = reformartErrorMsg(reqdata.response?.data?.error["server_mail.0.email"][1]);
        //   setShowErrorEmail(true)
        //   setErrorMessageEmail(errorMsg)
        // }
        if (reqdata.response?.data?.error["server_mail.0.password"] && reqdata.response?.data?.error["server_mail.0.password"][0]) {
          var errorMsg = reformartErrorMsg(reqdata.response?.data?.error["server_mail.0.password"][0]);
          setShowErrorPassword(true)
          setErrorMessagePassword(errorMsg)
        }
        if (reqdata.response?.data?.error["sms.0.code_iso"] && reqdata.response?.data?.error["sms.0.code_iso"][0]) {
          var errorMsg = reformartErrorMsg(reqdata.response?.data.error["sms.0.code_iso"][0]);
          setShowErrorIsoCode(true)
          setErrorMessageIsoCode(errorMsg)
        }
        if (reqdata.response?.data?.error["calendar.0.day_before_end"] && reqdata.response?.data?.error["calendar.0.day_before_end"][0]) {
          var errorMsg = reformartErrorMsg(reqdata.response?.data.error["calendar.0.day_before_end"][0]);
          setShowErrorNumberOfDaysGivenBeforeTransmission(true)
          setErrorMessageNumberOfDaysGivenBeforeTransmission(errorMsg)
        }
        if (reqdata.response?.data?.error["calendar.0.day_after_end"] && reqdata.response?.data?.error["calendar.0.day_after_end"][0]) {
          var errorMsg = reformartErrorMsg(reqdata.response?.data.error["calendar.0.day_after_end"][0]);
          setShowErrorNumberofDaysBeforeDueDate(true)
          setErrorMessageNumberofDaysBeforeDueDate(errorMsg)
        }
        if (reqdata.response?.data?.error["calendar.0.taux_maximal"] && reqdata.response?.data?.error["calendar.0.taux_maximal"][0]) {
          var errorMsg = reformartErrorMsg(reqdata.response?.data.error["calendar.0.taux_maximal"][0]);
          setShowErrorMaxRate(true)
          setErrorMessageMaxRate(errorMsg)
        }
        if (reqdata.response?.data?.error["notification.0.message_dsif_normal"] && reqdata.response?.data?.error["notification.0.message_dsif_normal"][0]) {
          var errorMsg = reformartErrorMsg(reqdata.response?.data.error["notification.0.message_dsif_normal"][0]);
          setShowErrorNotifMsgNormal(true)
          setErrorMessageNotifMsgNormal(errorMsg)
        }
        if (reqdata.response?.data?.error["notification.0.message_rappel_avant"] && reqdata.response?.data?.error["notification.0.message_rappel_avant"][0]) {
          var errorMsg = reformartErrorMsg(reqdata.response?.data.error["notification.0.message_rappel_avant"][0]);
          setShowErrorNotifMsgReminderBefore(true)
          setErrorMessageNotifMsgReminderBefore(errorMsg)
        }
        if (reqdata.response?.data?.error["notification.0.message_rappel_jj"] && reqdata.response?.data?.error["notification.0.message_rappel_jj"][0]) {
          var errorMsg = reformartErrorMsg(reqdata.response?.data.error["notification.0.message_rappel_jj"][0]);
          setShowErrorNotifMsgReminderPresent(true)
          setErrorMessageNotifMsgReminderPresent(errorMsg)
        }
        if (reqdata.response?.data?.error["notification.0.message_depassement_echeance"] && reqdata.response?.data?.error["notification.0.message_depassement_echeance"][0]) {
          var errorMsg = reformartErrorMsg(reqdata.response?.data.error["notification.0.message_depassement_echeance"][0]);
          setShowErrorNotifMsgReminderAfter(true)
          setErrorMessageNotifMsgReminderAfter(errorMsg)
        }
        if (reqdata.response?.data?.error["notification.0.message_dsif_grace"] && reqdata.response?.data?.error["notification.0.message_dsif_grace"][0]) {
          var errorMsg = reformartErrorMsg(reqdata.response?.data.error["notification.0.message_dsif_grace"][0]);
          setShowErrorNotifMsgGrace(true)
          setErrorMessageNotifMsgGrace(errorMsg)
        }


      } else {
        console.log(reqdata.response)
        // toast.error(reqdata.response?.data.error, {
        //     position: toast.POSITION.TOP_RIGHT
        // });
      }
    } else {
      setProcessOngoing(false)
      toast.success(`Nouvelle configuration enrégistrée !`, {
        position: toast.POSITION.TOP_RIGHT
      });

    }
  }


  return (
    <div>
      <Navbar />
      <div className="main-container" id="container">
        <Sidebar />

        <div id="content" className="main-content">
          <div className="layout-px-spacing">

            <div className="row layout-top-spacing">
              <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
              </div>
            </div>
            <h2 className="mb-3 text-left">Configuration</h2>
            {displayLoader == false ?
              <Fragment>
                {/* Section Server Mail */}
                <div className="widget widget-content widget-content-area p-3 mb-3">
                  <h5 className="mb-1 mt-2 text-left">Serveurs Mails</h5>
                  <hr className="mb-2" />
                  <div className="d-flex mt-3">
                    <div className="col-6">
                      <div class="form-group row mb-4">
                        <label for="libelle" class="col-sm-4 col-form-label col-form-label-sm text-dark required">Server</label>
                        <div class="col-sm-8">
                          <input type="text" onChange={(e) => handleChangeEntry("server", e)} className={showErrorServer == true ? "form-control custom-form-control form-control-sm new-agent-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={configuration.server} required />
                          {showErrorServer === true && <span className="new-agent-error-span">{errorMessageServer}</span>}
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div class="form-group row  mb-4">
                        <label for="libelle" class="col-sm-4 col-form-label col-form-label-sm text-dark required">Port</label>
                        <div class="col-sm-8">
                          <input type="number" onChange={(e) => handleChangeEntry("port", e)} className={showErrorPort == true ? "form-control custom-form-control form-control-sm new-agent-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={configuration.port} required />
                          {showErrorPort === true && <span className="new-agent-error-span">{errorMessagePort}</span>}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex mt-3">
                    <div className="col-6">
                      <div class="form-group row mb-4">
                        <label for="libelle" class="col-sm-4 col-form-label col-form-label-sm text-dark required">Email</label>
                        <div class="col-sm-8">
                          <input type="email" onChange={(e) => handleChangeEntry("email", e)} className={showErrorEmail == true ? "form-control custom-form-control form-control-sm new-agent-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={configuration.email} required />
                          {showErrorEmail === true && <span className="new-agent-error-span">{errorMessageEmail}</span>}
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div class="form-group row  mb-4">
                        <label for="password" class="col-sm-4 col-form-label col-form-label-sm text-dark required">Mot de passe</label>
                        <div class="col-sm-8">

                          <div class="input-group"
                            className={showErrorPassword == true ? "input-group new-institution-error-input" : "input-group"}
                          >
                            <input type={showPassword === true ? "text" : "password"} 
                              placeholder=""
                              className={"form-control custom-form-control form-control-sm mx-auto pwd-input-focus"}
                              onChange={(e) => handleChangeEntry("password", e)}
                              value={configuration.password} 
                              />
                            <div class="input-group-append" >
                              {<span class="input-group-text" id="basic-addon2">
                                {showPassword === false && <AiFillEyeInvisible style={{ cursor: "pointer" }} onClick={handleDisplayPassword} />}
                                {showPassword === true && <FiEye style={{ cursor: "pointer" }} onClick={handleDisplayPassword} />}
                              </span>}
                            </div>
                          </div>
                          {showErrorPassword === true && <span className="new-agent-error-span">{errorMessagePassword}</span>}
                        
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

                {/* Section Notif API/SMS*/}
                <div className="widget widget-content widget-content-area p-3 mb-3">
                  <h5 className="mb-1 mt-2 text-left">Notification / API SMS</h5>
                  <hr className="mb-2" />
                  <div className="d-flex mt-3">
                    <div className="col-8 text-left">
                      <div class="form-group row mb-4">


                        <div class="col-sm-8">
                          <span class="n-chk ">
                            <label class="new-control new-checkbox new-checkbox-rounded checkbox-dark">
                              <input type="checkbox" checked={configuration.smsNotif} onChange={(e) => handleChangeEntry("smsNotif", e)} class="new-control-input" />
                              <span class="new-control-indicator"></span> <span style={{ color: "#3b3f5c", opacity: "1", fontWeight: "bold" }} className="">Activer les notifications SMS</span>
                            </label>
                          </span>
                          {showErrorSmsNotif === true && <span className="new-agent-error-span">{errorMessageSmsNotif}</span>}
                        </div>

                      </div>

                    </div>

                  </div>
                  {configuration.smsNotif == true && <div className="d-flex mt-3 text-left">
                    <div className="col-sm-6 col-xs-12">
                      <div class="form-group row mb-4">
                        <label for="libelle" class="col-sm-3 col-form-label col-form-label-sm text-dark required">Code Iso</label>
                        <div class="col-sm-8">
                          <input type="text" onChange={(e) => handleChangeEntry("isoCode", e)} className={showErrorIsoCode == true ? "form-control custom-form-control form-control-sm new-agent-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={configuration.isoCode} required />
                          {showErrorIsoCode === true && <span className="new-agent-error-span">{errorMessageIsoCode}</span>}
                        </div>
                      </div>
                    </div>
                    <div className="col-6">

                    </div>
                  </div>}

                </div>

                {/* Section Messages de notification */}
                <div className="widget widget-content widget-content-area p-3 mb-3">
                  <h5 className="mb-1 mt-2 text-left">Messages de notification</h5>
                  <hr className="mb-2" />
                  <div className="d-flex mt-3">
                    <div className="col-12">
                      <div class="form-group row mb-4">
                        <label for="libelle" class="col-sm-12 col-form-label col-form-label-sm text-left text-dark required">Message de notification à envoyer au superviseur à la fin de la période normale de soumission avec le point des reporting</label>
                        <div class="col-sm-12">
                          <textarea rows="3" onChange={(e) => handleChangeEntry("notifMsgNormal", e)} className={showErrorNotifMsgNormal == true ? "form-control form-control-sm new-agent-error-input  mx-auto" : "form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={configuration.notifMsgNormal} required></textarea>
                          {showErrorNotifMsgNormal === true && <span className="new-agent-error-span">{errorMessageNotifMsgNormal}</span>}
                        </div>
                      </div>
                    </div>


                  </div>
                  <div className="d-flex mt-3">
                    <div className="col-12">
                      <div class="form-group row mb-4">
                        <label for="libelle" class="col-sm-12 col-form-label col-form-label-sm text-left text-dark required">Message de notification à envoyer au superviseur à la fin de la période de grâce de soumission avec le point des reporting </label>
                        <div class="col-sm-12">
                          <textarea rows="3" onChange={(e) => handleChangeEntry("notifMsgGrace", e)} className={showErrorNotifMsgGrace == true ? "form-control form-control-sm new-agent-error-input  mx-auto" : "form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={configuration.notifMsgGrace} required></textarea>
                          {showErrorNotifMsgGrace === true && <span className="new-agent-error-span">{errorMessageNotifMsgGrace}</span>}
                        </div>
                      </div>
                    </div>


                  </div>
                  <div className="d-flex mt-3">
                    <div className="col-12">
                      <div class="form-group row mb-4">
                        <label for="libelle" class="col-sm-12 col-form-label col-form-label-sm text-left text-dark required">Message de notification à envoyer à l'établissement financier pour rappel de l’échéance (Avant le jour J) de soumission de reporting</label>
                        <div class="col-sm-12">
                          <textarea rows="3" onChange={(e) => handleChangeEntry("notifMsgReminderBefore", e)} className={showErrorNotifMsgReminderBefore == true ? "form-control form-control-sm new-agent-error-input  mx-auto" : "form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={configuration.notifMsgReminderBefore} required></textarea>
                          {showErrorNotifMsgReminderBefore === true && <span className="new-agent-error-span">{errorMessageNotifMsgReminderBefore}</span>}
                        </div>
                      </div>
                    </div>


                  </div>
                  <div className="d-flex mt-3">
                    <div className="col-12">
                      <div class="form-group row mb-4">
                        <label for="libelle" class="col-sm-12 col-form-label col-form-label-sm text-left text-dark required">Message de notification à envoyer à l'établissement financier pour rappel de l’échéance (Jour J) de soumission de reporting</label>
                        <div class="col-sm-12">
                          <textarea rows="3" onChange={(e) => handleChangeEntry("notifMsgReminderPresent", e)} className={showErrorNotifMsgReminderPresent == true ? "form-control form-control-sm new-agent-error-input  mx-auto" : "form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={configuration.notifMsgReminderPresent} required></textarea>
                          {showErrorNotifMsgReminderPresent === true && <span className="new-agent-error-span">{errorMessageNotifMsgReminderPresent}</span>}
                        </div>
                      </div>
                    </div>


                  </div>
                  <div className="d-flex mt-3">
                    <div className="col-12">
                      <div class="form-group row mb-4">
                        <label for="libelle" class="col-sm-12 col-form-label col-form-label-sm text-left text-dark required">Message de notification à envoyer Au Directeur de l'établissement financier pour avertir du depassement de l’échéance de soumission de reporting </label>
                        <div class="col-sm-12">
                          <textarea rows="3" onChange={(e) => handleChangeEntry("notifMsgReminderAfter", e)} className={showErrorNotifMsgReminderAfter == true ? "form-control form-control-sm new-agent-error-input  mx-auto" : "form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={configuration.notifMsgReminderAfter} required></textarea>
                          {showErrorNotifMsgReminderAfter === true && <span className="new-agent-error-span">{errorMessageNotifMsgReminderAfter}</span>}
                        </div>
                      </div>
                    </div>


                  </div>


                </div>

                {/* Section Configuration du calendrier de transmission TEG */}
                <div className="widget widget-content widget-content-area p-3 mb-3">
                  <h5 className="mb-1 mt-2 text-left">Calendrier de transmission TEG</h5>
                  <hr className="mb-4" />

                  {/*  */}
                  <div className="d-flex mt-3 text-left">
                    <div className="col-12 col-xs-12">
                      <div class="form-group row mb-2">
                        <label for="libelle" class="col-sm-9 col-xs-12 col-form-label col-form-label-sm text-dark required">Nombre de jours accordés après la fin de mois pour effectuer la transmission du TEG</label>
                        <div class="col-sm-3 col-xs-12">
                          <input type="number" onChange={(e) => handleChangeEntry("numberOfDaysGivenBeforeTransmission", e)} className={showErrorNumberOfDaysGivenBeforeTransmission == true ? "form-control custom-form-control form-control-sm new-agent-error-input  mx-auto" : "custom-form-control form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={configuration.numberOfDaysGivenBeforeTransmission} required />
                          {showErrorNumberOfDaysGivenBeforeTransmission === true && <span className="new-agent-error-span">{errorMessageNumberOfDaysGivenBeforeTransmission}</span>}
                        </div>
                      </div>
                    </div>
                    <div className="col-6">

                    </div>
                  </div>
                  <div className="d-flex mt-3 text-left">
                    <div className="col-12 col-xs-12">
                      <div class="form-group row mb-2">
                        <label for="libelle" class="col-sm-9 col-xs-12 col-form-label col-form-label-sm text-dark required">Nombre de jours avant l'échéance pour notifier l'établissement</label>
                        <div class="col-sm-3 col-xs-12">
                          <input type="number" onChange={(e) => handleChangeEntry("numberofDaysBeforeDueDate", e)} className={showErrorNumberofDaysBeforeDueDate == true ? "form-control custom-form-control form-control-sm new-agent-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={configuration.numberofDaysBeforeDueDate} required />
                          {showErrorNumberofDaysBeforeDueDate === true && <span className="new-agent-error-span">{errorMessageNumberofDaysBeforeDueDate}</span>}
                        </div>
                      </div>
                    </div>
                    <div className="col-6">

                    </div>
                  </div>
                  {/*  */}

                </div>

                {/* Section Taux */}
                <div className="widget widget-content widget-content-area p-3 mb-3">
                  <h5 className="mb-1 mt-2 text-left">Taux</h5>
                  <hr className="mb-2" />
                  <div className="d-flex mt-3">
                    <div className="col-6">
                      <div class="form-group row mb-4">
                        <label for="libelle" class="col-sm-4 col-form-label col-form-label-sm text-dark required">Taux Maximal</label>
                        <div class="col-sm-8">
                          <input type="number" onChange={(e) => handleChangeEntry("maxRate", e)} className={showErrorMaxRate == true ? "form-control custom-form-control form-control-sm new-agent-error-input  mx-auto" : "custom-form-control form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={configuration.maxRate} required />
                          {showErrorMaxRate === true && <span className="new-agent-error-span">{errorMessageMaxRate}</span>}
                        </div>
                      </div>
                    </div>

                  </div>


                </div>

                <div className="new-agent-custom-modal-footer w-100 pb-3 mb-3">
                  {processOngoing == false ? <button type="button" className="btn btn-primary ml-3" onClick={handleSaveConfig}>Enregistrer les modifications</button>
                    :
                    <ProcessSpinner />}
                </div>
              </Fragment> :
              <div style={{ marginTop: "25%" }}>
                <Loader />
              </div>}
          </div>

        </div>
      </div>
    </div>)
}

export default Configuration